module.exports = __webpack_public_path__ + "static/media/logo.4e465b48.png";